import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IconsStatus, IIconsStatus } from '../../components/modal-status-groups/status';

@Component({
	selector: 'app-popover-status',
	templateUrl: './popover-status.component.html',
	styleUrls: ['./popover-status.component.scss'],
})
export class PopoverStatusComponent implements OnInit {
	icons = IconsStatus;
	@Output() private iconSelected = new EventEmitter<IIconsStatus>();
	constructor() {}

	ngOnInit(): void {}

	selected(icon: IIconsStatus) {
		this.iconSelected.emit(icon);
	}
}
